import { Button, Checkbox } from "react-aria-components"
import { modalSignal } from "./ModalContainer"
import infoIcon from "../../../assets/icons/icon-information.svg"
import { useState } from "react"
import Pill from "../Pill"
import CheckIcon from "../../../assets/icons/icon-check-white.svg"
import LoadingButton from "../LoadingButton"
import { StatusDto } from "../../../enums/Domain/Status"
import ReturnPartCasesPanel from "./ReturnPartCasesPanel"
import NotesTooltip from "../recallWizard/NotesTooltip"

interface IExistingCasesModal {
    heading: string,
    information: string,
    ContinueFunc: Function,
    cancelFunc?: Function
    autoClose?: boolean | null | undefined,
    existingCases: IExistingCase[],
    clearValues: Function,
    packingBoxId: string
}

export interface IExistingCase {
    id: string, 
    rangeId: string, 
    prefix: string,
    notes: string,
    status: StatusDto,
}

export default function ExistingCasesModal({ heading, information, ContinueFunc, cancelFunc, autoClose, existingCases, clearValues, packingBoxId }: IExistingCasesModal) {
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedCaseToReturn, setSelected] = useState<string | null | undefined>(null);
    const [partCasesCaseId, setPartCasesCaseId] = useState<string | null>(null);

    async function handleContinue() {
        setLoading(true);
        await ContinueFunc(selectedCaseToReturn);
        if(clearValues) {
            clearValues();
        }
        setLoading(false);
        if (autoClose == undefined || autoClose === null || autoClose === true) {
            modalSignal.value = undefined;
        }
    }

    function handleCancel() {
        modalSignal.value = undefined;
        if (cancelFunc) {
            cancelFunc();
        }
    }

    async function handleReturnPartCases(caseId: string) {
        if (partCasesCaseId === caseId) {
            setPartCasesCaseId(null);
            return;
        }
        setPartCasesCaseId(caseId);
    }


    if (partCasesCaseId) {
        return (
            <ReturnPartCasesPanel
                caseId={partCasesCaseId}
                packingBoxId={packingBoxId}
                onReturn={() => setPartCasesCaseId(null)}
                onCancel={() => setPartCasesCaseId(null)}
                clearValues={clearValues}
            />
        )
    }

    return (
        <div className="display--flex flex__direction--column alignItems--center gap--xs">
            <img src={infoIcon} />
            <h1>{heading}</h1>
            <p className="existing-cases__information textAlign--center whitespace--pre-line">{information}</p>
            <div className="existing-cases__wrapper">
                <div className="existing-cases__header">
                    <div className="existing-cases__header-notes">
                        <p className="small">Notes</p>
                    </div>
                    <div className="existing-cases__header-prefix">
                        <p className="small">Prefix</p>
                    </div>
                    <div className="existing-cases__header-status">
                        <p className="small">Status</p>
                    </div>
                    <div className="existing-cases__header-button">
                        <p className="small"></p>
                    </div>
                    <div className="existing-cases__header-checkbox">
                        <p className="small">Return?</p>
                    </div>
                </div>
                <div className="existing-cases__list">
                    {existingCases.map((item) => (
                        <div key={item.id} className="existing-cases__row">
                            <div className="existing-cases__notes">
                                <NotesTooltip item={{
                                    id: item.id,
                                    resultType: "Whole Case",
                                    reference: item.prefix
                                }} />
                            </div>
                            <div className="existing-cases__prefix">
                                <p className="small small--2">{item.prefix ?? '--'}</p>
                            </div>
                            <div className="existing-cases__status">
                                <Pill statusDto={item.status} />
                            </div>
                            <div className="existing-cases__button">
                                <Button 
                                    className="button button--small button--secondary"
                                    onPress={() => handleReturnPartCases(item.id)}
                                    isDisabled={loading}>
                                    <p className="button-text">Part Cases</p>
                                </Button>
                            </div>
                            <div className="existing-cases__checkbox">
                                <Checkbox slot="selection" onChange={() => { 
                                    setSelected(selectedCaseToReturn === item.id ? null : item.id);
                                }}>
                                    <div className={`input-checkbox ${selectedCaseToReturn === item.id ? "input-checkbox--selected" : "input-checkbox--unselected"}`}>
                                        <img alt="" src={CheckIcon} />
                                    </div>
                                </Checkbox>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="margin__top--xs display--flex gap--xs">
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleCancel} isDisabled={loading}>
                    <p className="button-text">Back</p>
                </Button>
                <LoadingButton className="button button--large button--primary button--with-icon"
                    onPress={handleContinue}
                    buttonText="Return selected case"
                    loadingText="Packing"
                    isDisabled={loading || !selectedCaseToReturn}
                    isLoading={loading}>
                    <></>
                </LoadingButton>
            </div>
        </div>
    )
}


